// generated from 2_028 samples

import { z } from "zod";
import { common } from "../common";

export const interactedWithLocationSetTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::InteractedWithLocationSet"),
  // null: 28 (1.38%)
  // true 1_891 (94.55%), false 109 (5.45%)
  enter_event: z.boolean().nullable(),
  // null: 193 (9.52%)
  // true 439 (23.92%), false 1_396 (76.08%)
  exit_event: z.boolean().nullable(),
  // undefined: 28 (1.38%), defined 2_000 (98.62%)
  location_set_id: common.objectId.optional(),
  // undefined: 28 (1.38%), defined 2_000 (98.62%)
  location_set_name: z.string().optional(),
});
